import editIconSvg from "static/images/edit-icon.svg";
import regenerateIcon from "static/images/reload-icon.svg";
import IconLinkButton from "components/common/controls/IconLinkButton";
import { connect } from "react-redux";
import SubscriptionTokenResponse from "interfaces/response/SubscriptionTokenResponse";

interface Props {
  data: any;
  onEditClick: (data: SubscriptionTokenResponse) => void;
  onRegenerateClick: (data: SubscriptionTokenResponse) => void;
}

export function ManageTokenGridActions(props: Props) {
  const { data, onEditClick, onRegenerateClick } = props;
  const handleEditTokenClick = () => {
    onEditClick(data.data);
  };

  const handleRegenerateClick = () => {
    onRegenerateClick(data.data);
  };

  return (
    <>
      <div className="space-x-3">
        <IconLinkButton
          responsiveBreakPoint="xl"
          text="Edit"
          icon={editIconSvg}
          onClick={handleEditTokenClick}
        />
        <IconLinkButton
          responsiveBreakPoint="xl"
          text="Regenerate"
          icon={regenerateIcon}
          onClick={handleRegenerateClick}
        />
      </div>
    </>
  );
}

export default connect()(ManageTokenGridActions);
